export const getAdminBrands = () =>
  /**
   * @param {import("stores/reducers").MainReducer} state
   */
  state => {
    return state.adminPages.brandUIDs;
  };
